/**
 * @generated SignedSource<<8f9514c39f5e1385bd0cddad75b4282c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type WorkspaceType = "GLOBAL_EXPERIENCE" | "PRODUCT";
export type OrganizationContextInput = {
  clientMutationId?: string | null;
  cloudId?: string | null;
  orgId: string;
};
export type BootstrapQuery$variables = {
  context?: OrganizationContextInput | null;
};
export type BootstrapQuery$data = {
  readonly userOrganizationByContext: {
    readonly cloudIds: ReadonlyArray<string | null> | null;
    readonly orgId: string | null;
    readonly workspaces: ReadonlyArray<{
      readonly cloudId: string;
      readonly id: string;
      readonly type: WorkspaceType;
      readonly uuid: string;
      readonly " $fragmentSpreads": FragmentRefs<"storeHomeWorkspace">;
    } | null> | null;
  } | null;
};
export type BootstrapQuery = {
  response: BootstrapQuery$data;
  variables: BootstrapQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "context"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "organizationContext",
    "variableName": "context"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "orgId"
},
v3 = {
  "kind": "ScalarField",
  "name": "cloudIds"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v6 = {
  "kind": "ScalarField",
  "name": "cloudId"
},
v7 = {
  "kind": "ScalarField",
  "name": "type"
},
v8 = {
  "kind": "ScalarField",
  "name": "name"
},
v9 = {
  "kind": "ScalarField",
  "name": "keyPrefix"
},
v10 = {
  "kind": "ScalarField",
  "name": "timezone"
},
v11 = {
  "kind": "ScalarField",
  "name": "cloudName"
},
v12 = {
  "kind": "ScalarField",
  "name": "organisationId"
},
v13 = {
  "kind": "ScalarField",
  "name": "goalScoringMode"
},
v14 = {
  "kind": "ScalarField",
  "name": "userIsOrgAdmin"
},
v15 = {
  "kind": "ScalarField",
  "name": "activationId"
},
v16 = {
  "concreteType": "WorkspaceAIConfig",
  "kind": "LinkedField",
  "name": "aiConfig",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "enabled"
    }
  ]
},
v17 = {
  "concreteType": "UserWorkspacePermissions",
  "kind": "LinkedField",
  "name": "userWorkspacePermissions",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "admin"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "BootstrapQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "userOrganizationByContext",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "concreteType": "Workspace",
            "kind": "LinkedField",
            "name": "workspaces",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "kind": "InlineDataFragmentSpread",
                "name": "storeHomeWorkspace",
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v6/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v7/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/)
                ],
                "argumentDefinitions": []
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BootstrapQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "userOrganizationByContext",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "concreteType": "Workspace",
            "kind": "LinkedField",
            "name": "workspaces",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/)
            ]
          },
          (v4/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "7c1ce3b784aad5e79617360f766649f0",
    "id": null,
    "metadata": {},
    "name": "BootstrapQuery",
    "operationKind": "query",
    "text": "query BootstrapQuery(\n  $context: OrganizationContextInput\n) {\n  userOrganizationByContext(organizationContext: $context) {\n    orgId\n    cloudIds\n    workspaces {\n      id\n      uuid\n      cloudId\n      type\n      ...storeHomeWorkspace\n    }\n    id\n  }\n}\n\nfragment storeHomeWorkspace on Workspace {\n  id\n  uuid\n  name\n  keyPrefix\n  timezone\n  cloudId\n  cloudName\n  organisationId\n  goalScoringMode\n  type\n  userIsOrgAdmin\n  activationId\n  aiConfig {\n    enabled\n  }\n  userWorkspacePermissions {\n    admin\n  }\n}\n"
  }
};
})();

(node as any).hash = "18b464eae373168c4c74ac9c5512101c";

export default node;
